import {
  CATEGORY_RANKING_STAGE,
  type CategoryRankingStage,
} from '@/api/category-ranking/types';

const STAGE_LABELS: Record<CategoryRankingStage, string> = {
  [CATEGORY_RANKING_STAGE.GROUP_OUT]: 'Zona',
  [CATEGORY_RANKING_STAGE.ROUND64]: '32avos',
  [CATEGORY_RANKING_STAGE.ROUND32]: '16avos',
  [CATEGORY_RANKING_STAGE.ROUND16]: 'Octavos',
  [CATEGORY_RANKING_STAGE.QUARTERFINAL]: 'Cuartos',
  [CATEGORY_RANKING_STAGE.SEMIFINAL]: 'Semifinal',
  [CATEGORY_RANKING_STAGE.FINAL]: 'Final',
  [CATEGORY_RANKING_STAGE.CHAMPION]: 'Campeón',
};

export const getCategoryRankingStageLabel = (
  stage: CategoryRankingStage | string,
): string => STAGE_LABELS[stage as CategoryRankingStage] ?? stage;
